import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ShippingAddressSection = ({
  addressdata = [],
  setShowAddAddressModal,
  setDefultAddr,
  selectedAddressId,
  setSelectedAddressId,
  setEditAddressData,
  setShowEditAddressModal,
  item
}) => {
  const [expanded, setExpanded] = useState(false);

  //  Auto select default address & send to parent
  useEffect(() => {
    if (addressdata.length > 0) {
      const defaultAddr = addressdata.find((a) => a.is_default);

      if (defaultAddr) {
        setSelectedAddressId(defaultAddr.id);
        setDefultAddr(defaultAddr); // send full object to parent
      }
    }
  }, [addressdata, setSelectedAddressId, setDefultAddr]);

  const handleSelect = (addr) => {
    setSelectedAddressId(addr.id);  // store selected id in parent
    setDefultAddr(addr);            // send full address to parent
  };

  const displayedAddresses = expanded
    ? addressdata
    : addressdata.slice(0, 2);

  return (
    <div className="shipping-info-section">
      <div className="shipping-track">
        <div className="ship_info">
          <h4> 
            {/* <i className="bi bi-geo-alt-fill"></i>  */}
          {/* Shipping Information */}
            Select Delivery Address
           </h4>
        </div>

        <button
          onClick={() => setShowAddAddressModal(true)}
          className="add_ads"
           >
          <i className="bi bi-plus" /> Add New Address
        </button>
      </div>

      {displayedAddresses.map((addr) => (
        <div className="address-postiondefine"> 
            <label key={addr.id} className="address-option">
              <input
                type="radio"
                name="selectedAddress"
                checked={selectedAddressId === addr.id}
                onChange={() => handleSelect(addr)}
              />

              <div className="address-details">
                <div className="address-header_chk">
                  {addr.first_name} {addr.last_name}
                  <span className="address-type">
                    {addr.address_type}
                  </span>
                </div>

                <div className="address-body">
                  {addr.address}
                  {addr.address2 && `, ${addr.address2}`} 
                  {addr.city}, {addr.state}, {addr.pincode} <br />
                  {addr.country}
                </div>
              </div>
            </label>

            <span className="Editaddress" 
             onClick={() => {
                setEditAddressData({
                  id: addr.id,
                  first_name: addr.first_name || "",
                  last_name: addr.last_name || "",
                  mobile: addr.mobile || "",
                  pincode: addr.pincode || "",
                  state: addr.state || "",
                  city: addr.city || "",
                  address: addr.address || "",
                  address2: addr.address2 || "",
                  landmark: addr.landmark || "",
                  country: addr.country || "",
                  address_type: addr.address_type || "",
                });
                setShowEditAddressModal(true);
              }}
              title="Edit Address"
            >  <i class="bi bi-pencil-square"></i> </span>
            </div>
      ))}
     
      {addressdata.length > 2 && (
        <button
          className="show-toggle-btn"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};
export default ShippingAddressSection;